export enum Channels {
  eventsChannel = 'eventsChannel',
  serverChannel = 'serverChannel',
  errorsChannel = 'errorsChannel',
  navigationChannel = 'navigationChannel',
  dataChannel = 'dataChannel',
  routeChannel = 'routeChannel',
  routerChannel = 'routerChannel',
  nextActionChannel = 'nextActionChannel',
  locationChannel = 'locationChannel',
}
